import { atom, useRecoilState } from 'recoil'

const inputValuesState = atom ({
  key: 'inputValuesState',
  default: [
    {
      id:0,
      num:0,
    }
  ],
})

const currentNumState = atom({
  key: 'currentNumState',
  default: 0,
})


export const useInputValuesState = () => {
  const [inputValues, setInputValues] = useRecoilState(inputValuesState)
  const [currentNum, setCurrentNum] = useRecoilState(currentNumState)
  return {
    inputValues,
    setInputValues,
    currentNum,
    setCurrentNum
  }
}
